import Core from '../core'
import $ from 'jquery'

Core.Tasks.add(Core.Events.PAGE_COMPLETE, async () => {
    if ($('.c-slideshow').length > 0) {
        const module = await import('./views/slideshows-list-view')
        const SlideshowslistView = module.default
        new SlideshowslistView()
    }
})
